import React from 'react'
import { Link } from 'react-router-dom'
import { LatestEventsType } from '../../../models/latest-events-model'

const EventsCardArticle = (props: { article: LatestEventsType[] }) => {
  const article = props.article
  return (
    <div className="col-sm">
      <div className="feed-single">
        <img src={article?.slice(0).reverse()[0]?.sideImage} alt={article.slice(0).reverse()[0]?.eventName} loading="lazy" />
        <div className="feed-content">
          <Link to='/events'><h5>Events</h5></Link>
          <ul>
            {
              (article.length > 1) ? (
                article?.slice(0).reverse().map((item, index) => {
                  return <li key={index}>
                    <Link to={"/events/" + item.nodeName} dangerouslySetInnerHTML={{ __html: item.eventName }}></Link>
                  </li>
                })

              ) : (
                <li>
                  <Link to={article[0]?.nodeName} dangerouslySetInnerHTML={{ __html: article[0]?.eventName }}></Link>
                  {/* <p dangerouslySetInnerHTML={{__html: article[0]?.articleTeaserText}}></p> */}
                </li>
              )
            }
          </ul>
        </div>
        <div className="Newsrelink"></div>
      </div>
    </div>
  )
}

export default EventsCardArticle
